<template>
    <v-form @submit.prevent="addRecipients" ref="form">
        <v-card class="elevation-1 rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold">Add Recipients</span>
                <v-spacer></v-spacer>
                 <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
           
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support. {{errorMessage}}
            </v-alert>  

            <v-card-text>
                
                <!-- by employees -->
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-content">
                        <v-autocomplete
                            v-model="userIds"
                            :disabled="disabled"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Select Employees"
                            item-text="name"
                            item-value="userId"
                            multiple
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi ml-0">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>

            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="mr-25">
                <v-spacer></v-spacer>
                <v-btn type="submit" class="primary" :disabled="disabled||loading" :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>

    </v-form>
</template>
<script>
    
import edocumentsApi from '@/api/edocuments'
import employeeApi from '@/api/employees'
import pageKeys from '@/common/pagekeys'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    name: 'AddRecipients',
    data () {
        return {
            error: false,
            errorMessage: '',
            disabled: false,
            loading: false,
            loading_employees: false,

            //put this in rules-helper.js
            rules: {
                required: value => !!value || 'Required.',
                required_list: value => !!value.length || 'Required.',
                required_multiple: value => value.length>0 || 'Must select at least one month.',
            },

            employees: [],
            existing_recipients: [],

            documentId: null,
            versionNumber: null,
            userIds: [],
        }
    },
    methods: {
        async addRecipients() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate()) {
                    const data = {
                        documentId: this.documentId,
                        versionNumber: this.versionNumber,
                        userIds: this.userIds
                    }
                    const response = await edocumentsApi.addRecipients(data)
                    if (response && response.status == 200) {
                        this.$emit('send', response.data)
                        this.$emit('update:dialogAddRecipients', false)
                    }
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAllByPageKey(pageKeys.edocuments)
                if (response && response.status == 200) {
                    //exclude those already exist
                    const filtered = response.data.employees.filter(user => {
                        return !this.existing_recipients.some(x => x.userId == user.userId) 
                    });
                    filtered.forEach(item => {
                        this.employees.push({
                            userId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                            firstName: item.firstName,
                            lastName: item.lastName,
                            email: item.email,
                            group: item.team
                        })
                    })
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        setData(data) {
            console.log('setAdd')
            console.log(data)

            this.clearForm()
            this.documentId = data.documentId
            this.versionNumber = data.versionNumber
            this.existing_recipients = data.recipients

            console.log('this.existing_recipients')
            console.log(this.existing_recipients)

            this.getEmployees()
        },
        async closeDialog() {
            this.$emit('update:dialogAddRecipients', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.error = false
            this.errorMessage = ''
            this.loading = false
        },
    },
}
</script>
<style scoped>
.form-content {
    padding:0px 20px 0px 20px;
    margin-top:-5x;
}
</style>